import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "track-setting-content" }
const _hoisted_2 = {
  key: 0,
  class: "role-select"
}
const _hoisted_3 = { class: "role-select-content" }
const _hoisted_4 = { class: "role-select-content-header" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "role-select-content-cascade" }
const _hoisted_8 = { class: "role-select-content-header" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "role-select-content-list" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "role-select-content-list-item-title" }
const _hoisted_13 = { class: "role-select-footer" }
const _hoisted_14 = {
  key: 1,
  class: "track-select"
}
const _hoisted_15 = { class: "track-select-header" }
const _hoisted_16 = { class: "track-select-title" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "right" }
const _hoisted_20 = { class: "track-select-count" }
const _hoisted_21 = { class: "track-select-content" }
const _hoisted_22 = { class: "track-select-content-list-item-title" }
const _hoisted_23 = { class: "track-select-footer" }

import { provinceAndCityData } from 'element-china-area-data';
import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
import { roleSelectLists } from './config';
import { fetchTrackList, fetchUpdateTrade, fetchGetAppUserInfo } from '@/request/aiAction';
import { useUserStore } from '@/pinia';
import { emitter } from '@/utils/events';

interface Role {
  id: number;
  active: boolean;
  img: string;
  title: string;
}
interface Track {
  id: number;
  label: string;
  selected: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TrackSettingDialog',
  emits: ['trackSelectConfirm', 'handleClose'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore(); // 用户store

// 计算属性userInfo
const userInfo = computed(() => {
  return userStore.getUserInfo;
});

const emit = __emit;

const dialogVisible = ref(false); // 对话框是否显示
const trackType = ref('role'); // 赛道类型
const roleSelectList = ref<Role[]>(roleSelectLists); // 角色选择列表
const trackSelectList = ref<Track[]>([]); // 赛道选择列表
const currentTrack = ref<string[]>([]); // 当前选中的赛道
const currentRole = ref(''); // 当前选中的角色
const trackSelectMax = ref(1); // 赛道选择最大数量
const selectedRegion = ref<string[]>([]); // 选中的地区
// const store = useMainStore(); // 主store

// 处理赛道选择
async function handleTrackSelect(item: Track) {
  const index = currentTrack.value.findIndex((i) => i === item.label);

  if (index !== -1) {
    currentTrack.value.splice(index, 1);
  } else {
    if (currentTrack.value.length >= trackSelectMax.value) {
      currentTrack.value.pop();
    }
    currentTrack.value.unshift(item.label);
  }
}

// 处理级联选择器
function handleChange(value: string[]) {
  selectedRegion.value = value;
}

// 获取用户信息
async function getUserInfo() {
  const res: any = await fetchGetAppUserInfo();
  if (res) {
    let { data, code } = res.data;
    if (code !== 200) return;
    // localStorage.setItem('userInfo', JSON.stringify(data));
    const { trade = '', profession = '', area = '' } = data;
    currentTrack.value = trade ? trade.split(',') : [];
    currentRole.value = profession ? profession : '';
    selectedRegion.value = area ? area.split(',') : [];
    // 更新用户信息
    userStore.setUserInfo(data);
  }
}

function handleRoleSelectNext() {
  trackType.value = 'track';
}

// 处理赛道选择取消
function handleTrackSelectCancel() {
  trackType.value = 'role';
}

// 处理赛道选择确认
async function handleTrackSelectConfirm() {
  await fetchUpdateTrade({
    trade: currentTrack.value.join(','),
    profession: currentRole.value,
    area: Array.isArray(selectedRegion.value) && selectedRegion.value.length > 0 ? selectedRegion.value.join(',') : '',
  });
  // 还需要更新用户信息
  await getUserInfo();
  handleClose();
}

// 处理角色选择
function handleRoleSelect(item: Role) {
  currentRole.value = item.title;
  // trackType.value = "track";
}

// 关闭对话框
function handleClose() {
  dialogVisible.value = false;
  // 触发关闭事件
  emitter.emit('trackSettingDialogClosed');
}

// 通过接口获取行业列表
async function getTrackSelectList() {
  const res = await fetchTrackList();

  if (res) {
    const { user_industry_types = [] } = res.data.data;
    // 添加 "其他" 选项，使用自增ID
    const otherOption = {
      label: '其他',
      value: '其他',
    };

    trackSelectList.value = [...user_industry_types, otherOption];
  }
}

onMounted(() => {
  getTrackSelectList();
  // 监听打开弹窗事件
  emitter.on('openTrackSettingDialog', async () => {
    await getUserInfo();
    dialogVisible.value = true;
  });
});

// 组件销毁前移除事件监听
onBeforeUnmount(() => {
  emitter.off('openTrackSettingDialog');
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (dialogVisible.value)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        "append-to-body": "",
        title: "创作偏好设置",
        class: "custom-el-dialog",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "25%",
        onClose: handleClose,
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (trackType.value === 'role')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "role-select-header" }, [
                    _createElementVNode("div", { class: "role-select-title" }, "Hi！，我是你的专属内容运营助理小灵"),
                    _createElementVNode("div", { class: "role-select-desc" }, "很高兴陪伴你的创作，为了提供个性化辅助，请先告诉我你的创作偏好吧！")
                  ], -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        class: "role-select-img",
                        src: require('@/assets/images/ai-action/Locke-03.png'),
                        alt: ""
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[3] || (_cache[3] = _createTextVNode(" 你需要关联的地区是哪里? ")),
                        _createVNode(_component_el_tooltip, {
                          content: "当选择关联地区后，会根据地区推送相关热点以及内容",
                          placement: "top",
                          effect: "light"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createElementVNode("i", {
                              class: "ri-information-line",
                              style: {"font-size":"16px"}
                            }, null, -1)
                          ])),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_cascader, {
                        placeholder: "请选择地区",
                        size: "default",
                        style: {"width":"100%"},
                        options: _unref(provinceAndCityData),
                        modelValue: selectedRegion.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRegion).value = $event)),
                        onChange: handleChange
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "role-select-img",
                        src: require('@/assets/images/ai-action/Locke.png'),
                        alt: ""
                      }, null, 8, _hoisted_9),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "你是什么类型的创作者?", -1))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleSelectList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_card, {
                          class: _normalizeClass(["role-select-content-list-item", currentRole.value === item.title ? 'active' : '']),
                          style: {"text-align":"center"},
                          onClick: ($event: any) => (handleRoleSelect(item))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              class: "role-select-content-list-item-img",
                              src: item.img,
                              alt: ""
                            }, null, 8, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_button, {
                        class: "role-select-footer-left",
                        type: "default",
                        onClick: handleRoleSelectNext
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("下一步")
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (trackType.value === 'track')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("img", {
                          class: "track-select-img",
                          src: require('@/assets/images/ai-action/Locke-2.png'),
                          alt: ""
                        }, null, 8, _hoisted_18),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "选择你的创作行业", -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(currentTrack.value.length) + " / " + _toDisplayString(trackSelectMax.value), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_el_scrollbar, {
                      height: "400px",
                      class: "track-select-content-list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trackSelectList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_col, {
                                span: 6,
                                key: item.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_card, {
                                    class: _normalizeClass(["track-select-content-list-item", currentTrack.value.includes(item.label) ? 'active' : '']),
                                    onClick: ($event: any) => (handleTrackSelect(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_22, _toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_el_button, {
                      class: "track-select-footer-left",
                      type: "default",
                      onClick: handleTrackSelectCancel
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("上一步")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      class: "track-select-footer-right",
                      type: "primary",
                      onClick: handleTrackSelectConfirm
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("我选完了")
                      ])),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})